import { io } from 'socket.io-client';
const backend_url = 'https://real-time-collaboration-editor-2.onrender.com/';
export const initSocket = async () => {
    const options = {
        'force new connection': true,
        reconnectionAttempt: 'Infinity',
        timeout: 10000,
        transports: ['websocket'],
    };
    return io(backend_url, options);
};
